import React from 'react'
import EditGreenMarkProject from '../../../features/greenMarkProject/component/editGreenMarkProject.js'
const EditGmProject = () => {
  return (
    <div><EditGreenMarkProject/></div>
  )
}

export default EditGmProject